import React, { PureComponent } from 'react';
import { Card, Steps, Button, message, notification, Spin, Tooltip } from 'antd';
import PageHeaderWrapper from '@/components/PageHeaderWrapper';
import styles from './Index.less';
import router from 'umi/router';
import AccountProvider from '@/components/CloudAccounts/AccountProvider';
import AuthenticationMethod from '@/components/CloudAccounts/AuthenticationMethod';
import randomString from 'random-string';
import { getRegions } from '@/helpers/getRegions';
import { currentUserDetail } from '@/services/user';
import { connect } from 'dva';
import AccountCompletion from '@/components/CloudAccounts/AccountCompletion';
import { ArrowRightOutlined } from '@ant-design/icons';
import { PATH_DASHBOARD } from '@/utils/routes/path';
import { formatRoleNames } from '@/utils/utils';

@connect(({ user, organisation, cloudAccount, login }) => ({
  organisation: organisation.current,
  packageExpiry: organisation.packageExpiry,
  cloudAccount,
  deployStackCheckboxDisabled: cloudAccount.deployStackCheckboxDisabled,
  disableRunScanButton: cloudAccount.disableRunScanButton,
  viewListButton: cloudAccount.viewListButton,
  loadingRunScanButton: cloudAccount.loadingRunScanButton,
  isAccountAddedSuccessfully: cloudAccount.isAccountAddedSuccessfully,
  currentStatus: cloudAccount.currentStatus,
  xrayEnabledCloudProviders: login.xrayEnabledCloudProviders,
  cloudViewEnabledCloudProviders: login.cloudViewEnabledCloudProviders,
  userName: user.currentUser.name,
  testConnectionTypes: cloudAccount.testConnectionTypes,
}))
class AddUserAccount extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      addAccFail: '',
      showAssetApi: false,
      showAddErrMsg: '',
      current: 0,
      accountProvider: {
        value: '',
        accountName: '',
        protectionLevel: '',
      },
      authMethodData: {
        roleArn: '',
        deployedCftCheck: false,
        region: 'us-east-1',
        externalId: randomString({ length: 20 }),
        accountId: '330205083227',
        policy: 'Security Audit Policy',
      },
      authMethodDataAZ: {
        SubscriptionID: '',
        AppId: '',
        secret: '',
        TenantID: '',
      },
      authMethodDataGCP: {},
      roleNames: {
        cloudnosysCreateRole: '',
        cloudnosysDeleteRole: '',
      },
    };
    this.setCloudAccountData = this.setCloudAccountData.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.cloudAccount.statusOperation !== this.props.cloudAccount.statusOperation &&
      prevProps.cloudAccount.statusOperation === ''
    ) {
      if (this.props.cloudAccount.statusOperation === 'error') {
        this.setState({
          visible: true,
          addAccFail: true,
          current: 2,
          ...(this.props.cloudAccount.errorMessage && {
            showAddErrMsg: this.props.cloudAccount.errorMessage,
            showAssetApi: true,
          }),
        });
      }
      if (this.props.cloudAccount.statusOperation === 'success') {
        this.setState({
          visible: true,
          addAccFail: false,
          showAssetApi: false,
          current: 2,
        });
      }
    }
    const updateRegions = getRegions(this.state.accountProvider.value);
    if (
      this.state.current === 0 &&
      this.state.selectedRegions &&
      this.state.selectedRegions.length === 0
    ) {
      this.setState({
        selectedRegions: updateRegions,
      });
    }

    // *if account is added successfully, and scan is also completed, then redirect to dashboard only for aws
    if (
      this.props.isAccountAddedSuccessfully &&
      this.props.currentStatus === 'completed-scan' &&
      prevProps.currentStatus !== this.props.currentStatus &&
      this.state.accountProvider.value.toLowerCase() === 'aws'
    ) {
      this.handleFinish();
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'cloudAccount/save',
      payload: {
        isAccountAddedSuccessfully: false,
        // currentStatus: '',
      },
    });
  }

  selectedPolicy = policy => {
    let authMethodData = { ...this.state.authMethodData };
    authMethodData.policy = policy;
    this.setState({
      authMethodData,
    });
  };

  handleFinish = () => {
    router.push(PATH_DASHBOARD.monitoring.securityDashboard);
  };

  addAccount = async () => {
    const { dispatch, organisation, userName, cloudViewEnabledCloudProviders } = this.props;
    const {
      authMethodData,
      authMethodDataAZ,
      authMethodDataGCP,
      accountProvider,
      roleNames,
    } = this.state;

    const formattedRoleNames = formatRoleNames(roleNames);

    let userRes = await currentUserDetail();
    if (accountProvider.value.toLowerCase() !== 'gcp') await this.formRef.validateForm();
    let userData = await userRes.data();
    const { isVerified } = userData;
    if (!isVerified) {
      notification.error({
        message: 'Your email is not verified.',
      });
      return;
    }

    let newAccountData = {
      provider: accountProvider.value,
      accountName: accountProvider.accountName,
      protectionLevel: accountProvider.protectionLevel,
      orgId: organisation.id,
      credentialsAZ: { ...authMethodDataAZ },
      credentials: { ...authMethodData },
      credentialsGCP: { ...authMethodDataGCP },
      roleNames: { ...formattedRoleNames },
      userId: userData.uid,
      createdBy: userName,
      status: 'start-scan',
      statusMsg: 'Scan initialized by client side',
    };
    // adding cloud view config
    if (cloudViewEnabledCloudProviders.includes(accountProvider.value.toLowerCase())) {
      newAccountData = {
        ...newAccountData,
        cloudViewConfig: {
          status: 'start-scan',
          createdAt: new Date(),
        },
      };
    } else {
      newAccountData = {
        ...newAccountData,
        cloudViewConfig: {
          status: 'not-configured',
          createdAt: new Date(),
        },
      };
    }
    dispatch({
      type: 'cloudAccount/create',
      payload: {
        params: {
          orgId: organisation.id,
        },
        data: newAccountData,
      },
    });
  };

  // this function calls effect to test connection/APIs
  testCloudApis = async () => {
    const { dispatch, organisation } = this.props;
    const {
      authMethodData,
      authMethodDataGCP,
      authMethodDataAZ,
      accountProvider,
      roleNames,
    } = this.state;
    let userRes = await currentUserDetail();
    let userData = await userRes.data();
    const { isVerified } = userData;
    if (!isVerified) {
      return notification.error({
        message: 'Your email is not verified!',
      });
    }

    const { roleArn } = this.state.authMethodData;

    const payloadForTestConnectionAWS = {
      roleArn,
      externalId: organisation.id, // we're using org id as external id
      testApisOnly: false,
      protectionLevel: this.state.accountProvider.protectionLevel,
      cxrRegion: authMethodData.region,
      provider: this.state.accountProvider.value.toLowerCase(),
    };

    const payloadForTestConnectionGCP = {
      testApisOnly: false,
      protectionLevel: this.state.accountProvider.protectionLevel,
      externalId: organisation.id,
      isEditCloudAccount: false,
      provider: this.state.accountProvider.value.toLowerCase(),
      serviceAccount: authMethodDataGCP.service_account,
      authKey: authMethodDataGCP.authKey,
      roleNames: formatRoleNames(roleNames),
    };

    const credentials = {
      clientId: authMethodDataAZ.AppId,
      secret: authMethodDataAZ.secret,
      domain: authMethodDataAZ.TenantID,
      subscriptionId: authMethodDataAZ.SubscriptionID,
    };
    const payloadForTestConnectionAzure = {
      credentials: JSON.stringify(credentials),
      isEditCloudAccount: false,
      testApisOnly: false,
      protectionLevel: this.state.accountProvider.protectionLevel,
      provider: this.state.accountProvider.value.toLowerCase(),
    };

    dispatch({
      type: 'cloudAccount/testApis',
      payload:
        accountProvider.value.toLowerCase() === 'gcp'
          ? payloadForTestConnectionGCP
          : accountProvider.value.toLowerCase() === 'aws'
          ? payloadForTestConnectionAWS
          : payloadForTestConnectionAzure,
    });
  };

  setCloudAccountData = (step, value) => {
    this.setState(state => {
      return {
        ...state,
        [step]: {
          ...state[step],
          ...value,
        },
      };
    });
  };

  validator = async (stepType, data) => {
    const { dispatch, organisation } = this.props;
    const { accountProvider, authMethodDataGCP } = this.state;
    if (stepType === 'accountProvider') {
      if (!data.value) {
        message.error('Please select a cloud provider');
        return false;
      }
      if (!data.accountName) {
        message.error('Please enter account name');
        return false;
      }
      if (!data.protectionLevel.length) {
        message.error('Please select a protection level');
        return false;
      }
      if (
        this.props.cloudAccount.allCloudAccountsList.some(
          account => account.accountName === data.accountName.trim()
        )
      ) {
        message.error('This cloud account name is already taken. Please try another..');
        return false;
      }
      // dispatching the below effect to create cloud account id that'll be used in deploy cft url.
      dispatch({
        type: 'cloudAccount/createCloudAccountIdAndAuthKeys',
        payload: {
          organisationId: organisation.id,
          accountProvider: data.value,
        },
      });
    }
    if (stepType === 'authMethodData') {
      if (accountProvider.value === 'AWS') {
        if (!data.roleArn) {
          message.error('Please enter Role ARN');
          return false;
        }
      }
      if (accountProvider.value === 'GCP') {
        if (!authMethodDataGCP.service_account) {
          message.error('Please enter Service Account');
          return false;
        }
      }
      if (
        accountProvider.value === 'AWS' &&
        !data.deployedCftCheck &&
        this.state.accountProvider.protectionLevel.toLowerCase() !== 'basic'
      ) {
        message.error(
          `Please ensure that you've deployed the CFT in the cloud account & acknowledged as well via clicking the checkbox.`
        );
        return false;
      }
    }
    return true;
  };

  prev() {
    let { current } = this.state;
    current -= 1;
    this.setState({ current });
  }

  next(stepSelected) {
    const proceed = this.validator(stepSelected, this.state[stepSelected]);
    if (proceed) {
      let { current, accountProvider } = this.state;
      const { value } = accountProvider;
      current += 1;
      if (stepSelected.toLowerCase() === 'authmethoddata') {
        // ? call testApi for AWS & GCP accounts
        this.testCloudApis();

        // if (value.toLowerCase() !== 'azure') {
        //   this.testCloudApis();
        // }
        // //  ? add account for azure accounts
        // if (value.toLowerCase() === 'azure') {
        //   this.addAccount();
        //   return;
        // }
      }

      this.setState({ current });
    }
  }

  disableButton(buttonName) {
    const {
      current,
      accountProvider,
      authMethodData,
      authMethodDataGCP,
      authMethodDataAZ,
      roleNames,
    } = this.state;
    const { SubscriptionID, AppId, secret, TenantID } = authMethodDataAZ;

    const { packageExpiry, disableRunScanButton } = this.props;
    // disable every button if package is expired
    if (packageExpiry === 'expired') return true;

    if (buttonName === 'next') {
      if (current === 0) {
        // for first step
        if (
          !accountProvider.value ||
          !accountProvider.protectionLevel ||
          !accountProvider.accountName
        ) {
          return true;
        }
      }
      if (current === 1) {
        // for second step
        // for basic protection level (2nd Step)
        if (accountProvider.protectionLevel === 'basic') {
          // for basic protection level
          if (accountProvider.value.toLowerCase() === 'aws' && !authMethodData.roleArn) {
            return true;
          }
          if (accountProvider.value.toLowerCase() === 'gcp' && !authMethodDataGCP.service_account) {
            return true;
          }
          if (
            accountProvider.value.toLowerCase() === 'azure' &&
            (!SubscriptionID || !AppId || !secret || !TenantID)
          ) {
            return true;
          }
        }
        // for advanced protection level (2nd Step)
        if (accountProvider.protectionLevel === 'advanced') {
          if (
            accountProvider.value.toLowerCase() === 'aws' &&
            (!authMethodData.roleArn || !authMethodData.deployedCftCheck)
          ) {
            return true;
          }
          if (
            accountProvider.value.toLowerCase() === 'gcp' &&
            (!authMethodDataGCP.service_account ||
              !roleNames.cloudnosysCreateRole.length ||
              !roleNames.cloudnosysDeleteRole.length)
          ) {
            return true;
          }
          if (
            accountProvider.value.toLowerCase() === 'azure' &&
            (!SubscriptionID || !AppId || !secret || !TenantID)
          ) {
            return true;
          }
        }
      }
    }

    if (buttonName === 'finishAndRunScan') {
      if (disableRunScanButton || this.props.loadingRunScanButton) {
        return true;
      }
    }
    return false;
  }

  render() {
    const {
      addAccFail,
      authMethodData,
      authMethodDataAZ,
      authMethodDataGCP,
      showAddErrMsg,
      showAssetApi,
    } = this.state;
    const { allCloudAccountsList } = this.props.cloudAccount;
    const { packageExpiry, xrayEnabledCloudProviders } = this.props;

    if (this.state.addAccloading === true) {
      return <Spin />;
    }

    const { current } = this.state;
    const { Step } = Steps;
    let authData = {
      awsData: authMethodData,
      azureData: authMethodDataAZ,
      gcpData: authMethodDataGCP,
    };
    const steps = [
      {
        disabled: false,
        key: 'accountProvider',
        title: 'Selection',
        content: (
          <AccountProvider
            xrayEnabledCloudProviders={xrayEnabledCloudProviders}
            allCloudAccountsList={allCloudAccountsList}
            data={this.state.accountProvider}
            providerCallback={this.setCloudAccountData}
            setFormRef={ref => {
              this.formRef = ref;
            }}
          />
        ),
      },
      {
        disabled: false,
        key: 'authMethodData',
        title: 'Authentication',
        content: (
          <AuthenticationMethod
            key={this.props.cloudAccount.authorizerSecretKey}
            data={this.state.authMethodData}
            authData={authData}
            providerCallback={this.setCloudAccountData}
            accountProvider={this.state.accountProvider.value}
            accountName={this.state.accountProvider.accountName}
            protectionLevel={this.state.accountProvider.protectionLevel}
            roleNames={this.state.roleNames}
            setFormRef={ref => {
              this.formRef = ref;
            }}
            selectedPolicy={this.selectedPolicy}
          />
        ),
      },
      {
        disabled: false,
        key: 'completion',
        title: 'Testing',
        content: (
          <AccountCompletion
            cloudAccountProvider={this.state.accountProvider.value}
            protectionLevel={this.state.accountProvider.protectionLevel}
            addAccFail={addAccFail}
            showAddErrMsg={showAddErrMsg}
            showAssetApi={showAssetApi}
            testCloudApis={this.testCloudApis}
          />
        ),
      },
    ];
    return (
      <PageHeaderWrapper title="Add Cloud Account">
        <Card
          bordered={false}
          style={{ margin: '12px 0px 0px', marginTop: '12px', padding: '0 1.5rem' }}
        >
          <div>
            <Steps current={current} className={styles.steps}>
              {steps.map(item => (
                <Step
                  style={{ marginTop: 13 }}
                  key={item.key}
                  title={item.title}
                  disabled={item.disabled}
                />
              ))}
            </Steps>
            <div />
            <div style={{ marginTop: 10 }} className={styles.stepsContent}>
              {steps[current].content}
            </div>
            <div className={styles.stepsAction}>
              {/* FIRST STEP */}
              {current === 0 && (
                <Tooltip>
                  <Button
                    type="primary"
                    onClick={() => this.next(steps[current].key)}
                    disabled={this.disableButton('next')}
                  >
                    Next <ArrowRightOutlined />
                  </Button>
                </Tooltip>
              )}

              {/* SECOND STEP */}
              {current === 1 && (
                <Button style={{ marginRight: 8 }} onClick={() => this.prev()}>
                  Previous
                </Button>
              )}
              {current === 1 && this.state.accountProvider.value.length && (
                <Tooltip
                  title={
                    packageExpiry === 'expired'
                      ? 'You cannot create a new cloud account because your organization is expired.'
                      : current === 1 &&
                        this.props.deployStackCheckboxDisabled &&
                        this.state.accountProvider.value === 'AWS'
                      ? 'Please input all the fields and check the acknowledgement checkbox.'
                      : null
                  }
                >
                  <Button
                    type="primary"
                    onClick={() => this.next(steps[current].key)}
                    loading={this.props.loadingRunScanButton}
                    disabled={this.disableButton('next')}
                  >
                    {/* FOR AZURE AND GCP ACOUNT SHOW WE WILL HAVE MECAHNISM THAT WILL ADD ACCOUNT HERE */}
                    {/* {this.state.accountProvider.value.toLowerCase() === 'azure' && (
                      <>Test Connection & Add Cloud Account </>
                    )} */}

                    {/* FOR AWS JUST PERFORM THE NEXT STEP LOGIC */}
                    {
                      <>
                        Next <ArrowRightOutlined />
                      </>
                    }
                  </Button>
                </Tooltip>
              )}

              {/* THIRD / FINAL STEP */}
              {current === 2 && (
                <>
                  <Button style={{ marginRight: 8 }} onClick={() => this.prev()}>
                    Previous
                  </Button>
                  {/* <Button
                    // disabled={this.props.viewListButton || !addAccFail}
                    disabled={this.props.viewListButton}
                    style={{ marginRight: 25 }}
                    onClick={() => router.push(PATH_DASHBOARD.setup.cloudAccounts)}
                    htmlType="button"
                  >
                    View list
                  </Button> */}

                  {/* //*FINISH BUTTON FOR AWS ACCOUNT  */}
                  {
                    <Button
                      // disabled={this.disableButton('finishAndRunScan') || !addAccFail}
                      disabled={this.disableButton('finishAndRunScan')}
                      type="primary"
                      loading={this.props.loadingRunScanButton}
                      onClick={() => this.addAccount()}
                    >
                      Finish & Run Scan
                    </Button>
                  }
                  {/* //*FINISH BUTTON FOR AZURE AND GCP ACCOUNT  */}
                  {/* {this.state.accountProvider.value.toLowerCase() === 'azure' && (
                    <Button type="primary" onClick={this.handleFinish}>
                      Go to Dashboard
                    </Button>
                  )} */}
                </>
              )}
            </div>
          </div>
        </Card>
      </PageHeaderWrapper>
    );
  }
}
export default AddUserAccount;
